<template>
  <div class="feeConfigList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-input
            class="searchInput"
            v-model="name"
            placeholder="用户名"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            class="searchInput"
            v-model="module"
            placeholder="模块名"
          ></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="datevalues"
            type="daterange"
            :range-separator="$t('lang.lab_to')"
            :start-placeholder="$t('lang.lab_startDate')"
            :end-placeholder="$t('lang.lab_endDate')"
            value-format="timestamp"
          ></el-date-picker>
        </el-form-item>
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-table
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
      >
        <el-table-column type="selection" width="55" v-if="this.postAuditListcheckbox"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column prop="realName" label="用户名"></el-table-column>
        <el-table-column prop="module" label="模块名"></el-table-column>
        <el-table-column prop="reqUri" label="请求URL"></el-table-column>
        <el-table-column prop="reqMethod" label="请求方法"></el-table-column>
        <el-table-column prop="address" label="登录地点"></el-table-column>
        <el-table-column prop="ip" label="ip"></el-table-column>
        <el-table-column prop="name" label="操作类型">
          <template
            slot-scope="scope"
          >
          <el-tag size='medium' effect="dark" type="info">{{scope.row.name}}</el-tag>
        </template>
        </el-table-column>
        <el-table-column prop="duration" label="执行时长"></el-table-column>
        <el-table-column prop="status" label="操作状态">
          <template
            slot-scope="scope"
          >
          <el-tag size='medium' effect="dark" type="" v-if="scope.row.status == '1'">  {{scope.row.status == '1' ? '成功':'失败'}}</el-tag>
          <el-tag size='medium' effect="dark" type="danger" v-if="scope.row.status == '2'">  {{scope.row.status == '1' ? '成功':'失败'}}</el-tag>
        </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间">
          <template slot-scope="scope">{{ scope.row.createTime | time }}</template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:feeConfigList
 *@Description:收费设置
 *@author:xubz
 *@Copyright:格众科技
 *@date:2020-11-30
 */
export default {
  name: '/manage/main.feeConfig',
  data() {
    var chooseGardenId = (rule, value, callback) => {
      if (this.diaForm.gardenId === '') {
        callback(
          new Error(
            this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.diaFormgardenId')
          )
        )
      } else {
        callback()
      }
    }
    return {
      name:'',
      module:'',
      createTs:'',
      datevalues: [], 
      isFeeManagerList: this.$i18n.t('lang.AdminStrators.isFeeManagerList'), 
      isFeeManager: 0,
      zero: 0, // 值为0的变量
      multipleSelection: [], // 多选框
      pageCount: 0, // 总页数
      title: '', // 弹框显示的标题
      pageNo: 1, // 第几页
      pageSize: 10, // 每页显示数
      types: [], // 小区下拉
      houseId: 0, // 楼号ID
      unitId: 0, // 单元号ID
      houseList: [], // 楼号列表
      unitList: [], // 单元号列表
      tableData: [], // 列表数组
      searchFeeName: '', // 搜索的关键字
      disabled: true,
      editId: '', // 编辑按钮保存的id
      isPopupPage: false, // 弹框的显示控制
      gardenDialist: [], // 弹框的小区列表
      houseDialist: [], // 弹框的楼号列表
      unitDialist: [], // 弹框的单元列表
      saveData: '', // 存储json字符串
      diaForm: {
        isUpdateLift:0,
        gardenId: '',
        feeTypeCd: '',
        feeName: '',
        feeFlag: '',
        paymentCd: '1200',
        paymentCycle: '',
        billTypeName: '',
        billType: '',
        startTime: '',
        endTime: '',
        computingFormula: '',
        squarePrice: '',
        additionalAmount: '',
        feeClassify: '',
      },
      postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox, // 是否隐藏复选框
      isDisabled: true, // 保存的可点击
    }
  },
  created() {
    console.log(this.$store.getters)
    this.isFeeManager = this.$store.getters.isFeeManager
    this.getDatePicker()
    this.getTablelist()
  },
  watch: {
    diaForm: {
      handler(newVal, oldVal) {
        // form数据变化时 会调用此方法
        let tempRule = JSON.stringify(newVal)
        if (tempRule == this.saveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getDatePicker() {
       let d = new Date()
      let year1, month1, day1
      [year1, month1, day1] = [d.getFullYear(), d.getMonth() + 1, 0]
      let date1 = new Date(year1, month1, day1)
      this.datevalues.push(Date.parse(date1))
      // 前一天设定的日期时间
      let year2, month2, day2
      [year2, month2, day2] = [d.getFullYear(), d.getMonth(), 1]
      let date2 = new Date(year2, month2, day2)
      this.datevalues.unshift(Date.parse(date2))
    },
    //
    getTablelist() {
      var startTs = ''
      var endTs = ''
      if (this.datevalues != null) {
            if (this.datevalues.length > 0) {
              startTs = this.datevalues[0]
              endTs = this.datevalues[1]
            }
          }
      let loading = this.$loading()
      this.$get(
        `/sysLogOperateList/?name=${this.name}&pageNo=${this.pageNo}&pageSize=${this.pageSize}&module=${this.module}&startTs=${startTs}&endTs=${endTs}`
      ).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    commit() {
      this.pageNo = 1
      this.getTablelist()
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getTablelist()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getTablelist()
    },
    // 监听关闭dialog
    handleDialogClosed() {
      this.$refs.diaForm.resetFields()
      this.diaForm.unit = 0
      this.diaForm.house = 0
      this.diaForm.gardenId = ''
      this.diaForm.type = 1
      this.diaForm.name = ''
      this.diaForm.macName = ''
    },
    // 列表隔行变色
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
  }
}
</script>

<style lang="scss">
.nextPMTime label {
  width: 150px !important;
}

.el-dialog .el-form .el-form-item {
  margin-right: 0;
  margin-bottom: 15px !important;
  text-align: left;
}
</style>